import { useEffect } from 'react';
import { applyPageSeo, type PageSeoOptions } from '../lib/seo';

export function usePageSeo(options: PageSeoOptions): void {
  const jsonLdKey = options.jsonLd ? JSON.stringify(options.jsonLd) : '';

  useEffect(() => {
    return applyPageSeo(options);
  }, [
    options.title,
    options.description,
    options.path,
    options.image,
    options.imageAlt,
    options.type,
    options.noindex,
    options.publishedTime,
    options.modifiedTime,
    options.authorName,
    jsonLdKey,
  ]);
}
